import { useCallback, useMemo, useRef, useState } from "react"
import { getColumn } from "../helpers/coloumnsTag";
import { MessageAnt } from "../../../../redux/slices/ui/uiAction";
import { MessageType } from "../../../../types/messageType";
import { deleteTagsRequest, getTagsRequest, postTagsRequest, updateTagsRequest } from "../../../../config";

export const useTags = () => {
    const [stateTags, setStateTags] = useState({
        loadingForm: false,
        loading: true,
        columns: [],
        openModal: false,
        isEdit: false,
        formData: null,
    })
    const [table, setTable] = useState([])
    const idTag = useRef(null)

    const [searchValue, setSearchValue] = useState("")

    const tableFilterDataPlatforms = useMemo(() => {
        return table.filter((item) => {
            return item.name.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase());
        });
    }, [table, searchValue]);

    const updateTable = useCallback(
        (data = []) => {
            setTable(data)
            handleChangeSearch("")
        },
        [],
    )


    const getRequestTag = useCallback(
        async () => {
            const { status, payload } = await getTagsRequest()
            if (status > 0) return
            updateTable(
                payload
                    .sort((a, b) => a.value - b.value)
                    .map((p) => ({ ...p, key: p._id }))
            )
        },
        [updateTable],
    )

    const updateState = (key, value) => {
        setStateTags((prevState) => ({ ...prevState, [key]: value }));
    };

    const handleChangeSearch = (value) => {
        setSearchValue(value)
    }

    const onFinish = async (values) => {
        updateState("loadingForm", true)

        let formJson = {
            ...values,
            name: values.name.toUpperCase()
        }

        try {
            let isUpdate = false

            if (idTag.current) {
                const findById = table.find((t) => t.key === idTag.current)
                if (findById.name === formJson.name) {
                    delete formJson.name
                }
                const updateRequest = await updateTagsRequest(idTag.current, formJson)
                isUpdate = updateRequest.status === 0
            } else {
                const postRequest = await postTagsRequest(formJson)
                isUpdate = postRequest.status === 0
            }

            if (!isUpdate) {
                MessageAnt(MessageType.warning, !idTag.current ? "Fallo al crear" : "Fallo al editar");
                return
            }

            await getRequestTag()
            updateState("openModal", false)

        } catch (error) {
            console.log(error);
            MessageAnt(MessageType.warning, "Error de variables");
        } finally {
            updateState("loadingForm", false)
        }
    }

    const handleOnCancel = useCallback(
        () => {
            updateState("openModal", false)
        },
        [],
    )

    const handleOpenModal = useCallback(
        (data = null) => {
            idTag.current = data?.key || null
            updateState("isEdit", data !== null)
            updateState("formData", data)
            updateState("openModal", true)
        },
        [],
    )

    const handleDeleteRow = useCallback(
        async (id) => {
            try {
                updateState("loading", true)
                const deleteRequest = await deleteTagsRequest(id)

                if (deleteRequest.status > 0) {
                    MessageAnt(MessageType.warning, "Error al eliminar");
                }

                await getRequestTag()
            } catch (error) {
                MessageAnt(MessageType.warning, "Error al eliminar");
                console.log(id);
            } finally {
                updateState("loading", false)
            }
        },
        [getRequestTag],
    )

    const getTags = useCallback(
        async () => {
            updateState("loading", true)
            const columns = getColumn({
                editAction: handleOpenModal,
                deleteAction: handleDeleteRow
            })
            updateState("columns", columns)

            await getRequestTag()

            updateState("loading", false)
        },
        [handleOpenModal, handleDeleteRow, getRequestTag],
    )

    return {
        ...stateTags,
        table: tableFilterDataPlatforms,
        searchValue,
        getTags,
        handleOpenModal,
        handleOnCancel,
        handleChangeSearch,
        onFinish
    }
}
